import { render, staticRenderFns } from "./ReleaseOrderMenuItemEditor.vue?vue&type=template&id=4e483b44"
import script from "./ReleaseOrderMenuItemEditor.vue?vue&type=script&lang=js"
export * from "./ReleaseOrderMenuItemEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports